export const protocolsUS = ["Здесь будут протоколы узи"];
